<template>
    <div class="flex justify-center items-center space-x-2">
      <button
        :disabled="isPrevDisabled"
        @click="handlePrevPage"
        class="px-4 py-2 rounded border-none text-sm font-semibold action-btn"
        :class="isPrevDisabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:shadow-lg shadow-md'"
      >
        {{ prevLabel }}
      </button>
      
      <span v-if="showPageIndicator" class="text-md text-gray-700">
         {{ currentPage }}
      </span>
      
      <button
        :disabled="isNextDisabled"
        @click="handleNextPage"
        class="px-4 py-2 rounded border-none text-sm font-semibold action-btn"
        :class="isNextDisabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:shadow-lg shadow-md'"
      >
        {{ nextLabel }}
      </button>
    </div>
</template>

<script>
export default {
  name: "BaseCursorPagination",
  emits: ["pageChange", "update:currentPage"],
  props: {
    meta: {
      type: Object,
      default: () => ({
        next_cursor: null,
        prev_cursor: null
      })
    },

    currentPage: {
      type: Number,
      default: 1
    },

    prevLabel: {
      type: String,
      default: "PREV"
    },

    nextLabel: {
      type: String,
      default: "NEXT"
    },

    showPageIndicator: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    handlePrevPage() {
      if (this.meta && this.meta.prev_cursor) {
        this.$emit("pageChange", this.meta.prev_cursor);
        this.$emit("update:currentPage", Math.max(1, this.currentPage - 1));
      }
    },

    handleNextPage() {
      if (this.meta && this.meta.next_cursor) {
        this.$emit("pageChange", this.meta.next_cursor);
        this.$emit("update:currentPage", this.currentPage + 1);
      }
    },
  },

  computed: {
    isPrevDisabled() {
      return !this.meta?.prev_cursor;
    },

    isNextDisabled() {
      return !this.meta?.next_cursor;
    }
  }
};
</script>

<style scoped>
.action-btn{
  background-color: #f7fafc;
  outline: none;
}
</style>